<template>
    <v-stepper v-model="e1" >
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1" >{{ $t("races.backup.step_1_title") }}</v-stepper-step>
  
        <v-divider></v-divider>
  
        <v-stepper-step :complete="e1 > 2" step="2" >{{ $t("races.backup.step_2_title") }}</v-stepper-step>
  
        <v-divider></v-divider>
  
        <v-stepper-step :complete="e1 > 3" step="3" >{{ $t("races.backup.step_3_title") }}</v-stepper-step>
        
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-12">
            <v-btn color="primary"  class="btn_previous">
                {{ $t("races.backup.button_previous") }}
            </v-btn>
            <v-btn color="primary" @click="step2" class="btn_next">
                {{ $t("races.backup.button_next") }}
            </v-btn>
            <v-card-text class="text-left">
              <h2 class="text-center">
                {{ $t("races.backup.title_step_1") }}
              </h2>
              <p class="text-center">{{ $t("races.backup.content_step_1") }}</p>         
            </v-card-text>
            <v-row>
                <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <v-select
                      v-model="select_1"
                      :items="itemsSelect"
                      :label="`${titleS.toString()}`"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                </v-col>
            </v-row>
            <v-alert v-if="alert_2"
              color="red lighten-2"
              dark
            >
            {{ $t("races.backup.alert_step_1") }}
            </v-alert>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
            <v-card class="mb-12">
            <v-btn color="primary"   @click="e1 = 1" class="btn_previous">
                {{ $t("races.backup.button_previous") }}
            </v-btn>
            <v-btn color="primary" @click="e1 = 3" class="btn_next">
                {{ $t("races.backup.button_next") }}
            </v-btn>
            <v-card-text class="text-left">
              <h2 class="text-center">
                {{ $t("races.backup.title_step_2") }}
              </h2>
              <p class="text-center">{{ $tc("races.backup.content_step_2") }}</p>         
            </v-card-text>
            <v-row>
                <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="tableItems"
                    :items-per-page="-1"
                    :single-select="singleSelect"
                    item-key="race"
                    show-select
                    class="elevation-1"
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                  ></v-data-table>
                </v-col>
            </v-row>
            
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
            <v-card class="mb-12">
            <v-btn color="primary"   @click="e1 = 2" class="btn_previous">
                {{ $t("races.backup.button_previous") }}
            </v-btn>
            <v-btn color="primary" @click="createBackupRace" class="btn_next">
                {{ $t("races.backup.button_CreateRaceBackup") }}
            </v-btn>
            <v-card-text class="text-left">
              <h2 class="text-center">
                {{ $t("races.backup.title_step_3") }}
              </h2>
              <p class="text-center">{{ $tc("races.backup.content_step_3") }}
                <br>{{ $t("races.backup.content_step_31") }}
              </p> 
              <br>
              <v-checkbox required class="check"
                        v-model="checkbox"
                        :label="`${titleC.toString()}`"
                > </v-checkbox>    
            </v-card-text>
            <v-alert v-if="alert_3"
              color="red lighten-2"
              dark
            >
            {{ $t("races.backup.alert_step_3") }}
            </v-alert>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </template>
  
<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls], //for api redundant operations
  data() {
    return {      
      itemsSelect: [1,2,3,4,5],
      select_1:'',
      alert_2:false,
      alert_3:false,
      e1: 1,
      data:{},
      checkbox:0,
      tableItems: [],
      selected: [],
      singleSelect: false
    };
  },
  computed: {
    titleC() { return this.$t("races.backup.content_step_32"); },
    titleS() { return this.$t("races.backup.select_step_1"); }, 
    headers() {
      return [
          {
            text: this.$t("races.backup.table_step_2_1"),
            value: "race",
          },
          { text: this.$t("races.backup.table_step_2_2"), 
            value: "date" 
          }
      ];
    }
  },
  mounted() {
    this.raceEvents();
  },
  methods: {
    async raceEvents() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/racesEvents/" +
          this.$route.params.id
      );

      response.message.forEach( value => {
          this.tableItems.push({
            race: `${value.race}  - ${value.raceId}`,
            date: value.date,
            id: value.raceId
          });
      });

    },
    step2(){
      if(this.select_1!=''){
        this.alert_2=false
        this.e1 = 2 
      }
      else
        this.alert_2=true
    },
    async createBackupRace(){
      let formData = new FormData();
      let response = {};
          if(this.checkbox){
            this.alert_3=false
            this.selected.forEach(value =>{
                formData.append('raceId', value.id);
                formData.append('amount', this.select_1);
              
                response =  this.api(
                  "post",
                  "/api/v1/promoter/race/createBackupRace",
                  formData
                );
              
            });
            const resp = await response;
            if(resp.message){
              this.e1 =1
              this.select_1 = ''
              this.selected = []
              window.location.href = '/admin/raceDetails?raceId='+this.$route.params.id;
            } 
          }else{
              this.alert_3 = true
          }

    }
  }
};
</script>

  
  <style>

  .btn_next {
    float: right
  }
  .btn_previous {
    float: left
  }
  .check{
    margin-left: 35%;
  }
  </style>
  